/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Pathfinder API
 * API for all Pathfinder applications.
 * OpenAPI spec version: 1.0.0
 */
import type {
  PaginatedProgramAdmissionReadList,
  PatchedProgramAdmissionRequest,
  ProgramAdmission,
  ProgramAdmissionRead,
  ProgramAdmissionRequest,
  ProgramsAdmissionsListParams
} from '../types';

import { apiV2 } from '../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const programsAdmissionsList = (
    params?: ProgramsAdmissionsListParams,
 options?: SecondParameter<typeof apiV2<PaginatedProgramAdmissionReadList>>,) => {
      return apiV2<PaginatedProgramAdmissionReadList>(
      {url: `/programs/admissions/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const programsAdmissionsCreate = (
    programAdmissionRequest: ProgramAdmissionRequest,
 options?: SecondParameter<typeof apiV2<ProgramAdmission>>,) => {
      return apiV2<ProgramAdmission>(
      {url: `/programs/admissions/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: programAdmissionRequest
    },
      options);
    }
  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const programsAdmissionsRetrieve = (
    id: string,
 options?: SecondParameter<typeof apiV2<ProgramAdmissionRead>>,) => {
      return apiV2<ProgramAdmissionRead>(
      {url: `/programs/admissions/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const programsAdmissionsUpdate = (
    id: string,
    programAdmissionRequest: ProgramAdmissionRequest,
 options?: SecondParameter<typeof apiV2<ProgramAdmission>>,) => {
      return apiV2<ProgramAdmission>(
      {url: `/programs/admissions/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: programAdmissionRequest
    },
      options);
    }
  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const programsAdmissionsPartialUpdate = (
    id: string,
    patchedProgramAdmissionRequest?: PatchedProgramAdmissionRequest,
 options?: SecondParameter<typeof apiV2<ProgramAdmission>>,) => {
      return apiV2<ProgramAdmission>(
      {url: `/programs/admissions/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedProgramAdmissionRequest
    },
      options);
    }
  export type ProgramsAdmissionsListResult = NonNullable<Awaited<ReturnType<typeof programsAdmissionsList>>>
export type ProgramsAdmissionsCreateResult = NonNullable<Awaited<ReturnType<typeof programsAdmissionsCreate>>>
export type ProgramsAdmissionsRetrieveResult = NonNullable<Awaited<ReturnType<typeof programsAdmissionsRetrieve>>>
export type ProgramsAdmissionsUpdateResult = NonNullable<Awaited<ReturnType<typeof programsAdmissionsUpdate>>>
export type ProgramsAdmissionsPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof programsAdmissionsPartialUpdate>>>
